import(/* webpackMode: "eager" */ "/app/new-design/pale-blue-dot-redesign/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["TrailsExplorer"] */ "/app/new-design/pale-blue-dot-redesign/src/components/trails/TrailsExplorer.tsx");
